var map = {
	"./bg-beagrumb": "./app/javascript/images/bg-beagrumb.jpg",
	"./bg-beagrumb.jpg": "./app/javascript/images/bg-beagrumb.jpg",
	"./dummy-1895x196": "./app/javascript/images/dummy-1895x196.png",
	"./dummy-1895x196.png": "./app/javascript/images/dummy-1895x196.png",
	"./elta": "./app/javascript/images/elta.png",
	"./elta.png": "./app/javascript/images/elta.png",
	"./facebook": "./app/javascript/images/facebook.png",
	"./facebook.png": "./app/javascript/images/facebook.png",
	"./footer-image": "./app/javascript/images/footer-image.jpg",
	"./footer-image.jpg": "./app/javascript/images/footer-image.jpg",
	"./instagram": "./app/javascript/images/instagram.png",
	"./instagram.png": "./app/javascript/images/instagram.png",
	"./pinterest": "./app/javascript/images/pinterest.png",
	"./pinterest.png": "./app/javascript/images/pinterest.png",
	"./placeholder-logo": "./app/javascript/images/placeholder-logo.png",
	"./placeholder-logo.png": "./app/javascript/images/placeholder-logo.png",
	"./refresh": "./app/javascript/images/refresh.png",
	"./refresh.png": "./app/javascript/images/refresh.png",
	"./shopping-cart": "./app/javascript/images/shopping-cart.png",
	"./shopping-cart.png": "./app/javascript/images/shopping-cart.png",
	"./youtube": "./app/javascript/images/youtube.png",
	"./youtube.png": "./app/javascript/images/youtube.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";